import { restClient } from 'libs/restClient';
import {
  FETCH_BILLING_ADDRESSES,
  FETCH_REQUEST_BILLING_INFO,
  UPDATE_BILLING_INFO,
  SHOW_NOTICE
} from 'actions/types';
import { notifyMessages } from 'helpers/NotifyHelper';
import { prepareBillingArgs } from 'helpers/ArgsHelper';

export const fetchBillingAddresses = (companyId = null) => async dispatch => {
  try {
    // companyid uses in case if someone want to fetch data for different company
    // (e.g. Staff viewing Vendor's request)
    const urlTail = companyId ? `&where=companyid=${companyId}` : '';
    const url = `/addresses?perPage=50${urlTail}`;
    const response = await restClient.get(url);
    dispatch({ type: FETCH_BILLING_ADDRESSES, payload: response.data.data });
  } catch (e) {
    dispatch({
      type: SHOW_NOTICE,
      payload: notifyMessages.cantFetchBillingAddresses
    });
  }
};

export const fetchRequestBillingInfo = billingId => async dispatch => {
  try {
    const url = `/billings/${billingId}`;
    const response = await restClient.get(url);

    dispatch({ type: FETCH_REQUEST_BILLING_INFO, payload: response.data.data });
  } catch (e) {
    dispatch({
      type: SHOW_NOTICE,
      payload: notifyMessages.errorFetchRequestAction
    });
  }
};

export const updateBillingInfo = request => async dispatch => {
  try {
    const url = `/billings/${request.billingId}`;
    const body = prepareBillingArgs(request);
    const response = await restClient.put(url, body);

    dispatch({ type: UPDATE_BILLING_INFO, payload: response.data.data });
  } catch (e) {
    dispatch({
      type: SHOW_NOTICE,
      payload: notifyMessages.cantUpdateRequest
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/billing.js